export default class Role {
  id: string;

  name: string;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.name = obj.name || '';
  }

  public static of(obj: any): Role {
    return new Role(obj);
  }

  public static ofList(members: any): Role[] {
    return members.map((role: any) => new Role(role));
  }
}
